import { reaction } from 'mobx';

import { form } from 'src/stores';

import { REGISTRATION_LINKS_FORM_ID } from '../constants';

import { loadDistances } from '../actions';

import { disposersStore } from '../stores';

export const observeRaceField = () => {
  const disposer = reaction(
    () => form.fetch(REGISTRATION_LINKS_FORM_ID, 'race_id'),
    (race: AnyObject) => {
      form.onChange(REGISTRATION_LINKS_FORM_ID, 'distance_id', null);
      form.onChange(REGISTRATION_LINKS_FORM_ID, 'dates', null);
      form.onChange(REGISTRATION_LINKS_FORM_ID, 'wave_id', null);

      if (Boolean(race?.key)) {
        loadDistances(race.key);
      }
    },
  );

  disposersStore.register(disposer);
};
